import { DadosClienteProps } from "../../types/DadosClienteProps";
import InputMask from 'react-input-mask'

export function DadosFaturamento({ register, cliente, inputDisabled } : DadosClienteProps){
  return(
    <>
      <div className="w-full">
        <label className="font-[500]" htmlFor="EnderecoFaturamentoLogradouro">Logradouro</label>
        <input 
          type="text"
          {...register("EnderecoFaturamentoLogradouro")}
          defaultValue={cliente?.EnderecoFaturamentoLogradouro}
          disabled={inputDisabled}
          name="EnderecoFaturamentoLogradouro"
          maxLength={150}
          className="input-login-style w-full mb-5 disabled:text-[#B6B5B6] disabled:bg-[#F3F3F3]"
        />
      </div>
      <div className="flex flex-row flex-wrap justify-between">
        <div>
          <label className="font-[500]" htmlFor="EnderecoFaturamentoCidade">Cidade</label>
          <input 
            type="text"
            {...register("EnderecoFaturamentoCidade")}
            defaultValue={cliente?.EnderecoFaturamentoCidade}
            disabled={inputDisabled}
            name="EnderecoFaturamentoCidade"
            maxLength={50}
            className="input-login-style w-[25rem] mb-5 disabled:text-[#B6B5B6] disabled:bg-[#F3F3F3]"
          />
        </div>
        <div>
          <label className="font-[500]" htmlFor="EnderecoFaturamentoEstado">Estado</label>
          <input 
            type="text"
            {...register("EnderecoFaturamentoEstado")}
            defaultValue={cliente?.EnderecoFaturamentoEstado}
            disabled={inputDisabled}
            name="EnderecoFaturamentoEstado"
            maxLength={50}
            className="input-login-style w-[25rem] mb-5 disabled:text-[#B6B5B6] disabled:bg-[#F3F3F3]"
          />
        </div>
        <div>
          <label className="font-[500]" htmlFor="EnderecoFaturamentoCEP">CEP</label>
          <InputMask
            type="text"
            mask={"99999-999"}
            {...register("EnderecoFaturamentoCEP")}
            defaultValue={cliente?.EnderecoFaturamentoCEP}
            disabled={inputDisabled}
            name="EnderecoFaturamentoCEP"
            className="input-login-style w-[25rem] mb-5 disabled:text-[#B6B5B6] disabled:bg-[#F3F3F3]"
          />
        </div>
        <div>
          <label className="font-[500]" htmlFor="EnderecoFaturamentoPais">País</label>
          <input 
            type="text"
            {...register("EnderecoFaturamentoPais")}
            defaultValue={cliente?.EnderecoFaturamentoPais}
            disabled={inputDisabled}
            name="EnderecoFaturamentoPais"
            maxLength={50}
            className="input-login-style w-[25rem] mb-5 disabled:text-[#B6B5B6] disabled:bg-[#F3F3F3]"
          />
        </div>
        <div>
          <label className="font-[500]" htmlFor="EmailFinanceiro">Email Financeiro</label>
          <input
            type="email"
            {...register("EmailFinanceiro")}
            defaultValue={cliente?.EmailFinanceiro}
            disabled={inputDisabled}
            name="EmailFinanceiro"
            maxLength={50}
            className="input-login-style w-[25rem] mb-5 disabled:text-[#B6B5B6] disabled:bg-[#F3F3F3]"
          />
        </div>
      </div>
    </>
  );
}
